module.exports = __webpack_public_path__ + "img/6-threeImg.99238ad7.png";